import axiosHttp from "services/axiosHttp";
import insightsHttp from "services/insightsHttp";

// Task Service Functions
export const taskService = {
  // Create a single task
  createTask: async (data) => {
    const response = await axiosHttp.post("/pmo/task", data);
    return response.data;
  },

  // Create multiple tasks
  createMultipleTasks: async (data) => {
    const response = await axiosHttp.post("/pmo/task/multiple", data);
    return response.data;
  },

  // Get task list with optional params
  getTaskList: async (params = {}) => {
    const response = await axiosHttp.get("/pmo/task", { params });
    return response.data;
  },

  // Get single task by ID
  getTask: async (id) => {
    const response = await axiosHttp.get(`/pmo/task/${id}`);
    return response.data;
  },

  // Update a single task
  updateTask: async (id, data) => {
    const response = await axiosHttp.put(`/pmo/task/${id}`, data);
    return response.data;
  },

  // Update multiple tasks
  updateMultipleTask: async (data) => {
    const response = await axiosHttp.put(`/pmo/task/multiple`, data);
    return response.data;
  },

  // Delete a task
  deleteTask: async (id) => {
    const response = await axiosHttp.post(`/pmo/delete-task/${id}`);
    return response.data;
  },

  // Get tasks by user
  getTasksByUser: async (params = {}) => {
    const response = await axiosHttp.get(`/pmo/my/tasks`, { params });
    return response.data;
  },

  // Add time log to task
  addTaskTimeLog: async (data) => {
    const response = await axiosHttp.post("/pmo/task/add-time-log", data);
    return response.data;
  },

  // Add time log as admin 
  addAdminTaskTimeLog: async (data) => {
    const response = await axiosHttp.post("/pmo/task/admin-add-time-log", data);
    return response.data;
  },

  // Change task time log
  changeTaskTimeLog: async (data) => {
    const response = await axiosHttp.post("/pmo/task/change-time-log", data);
    return response.data;
  },

  checkIsLeave: async (data) => {
    const response = await axiosHttp.get("/pmo/my/is-leave", data);
    return response.data;
  },
  myTimeLog: async () => {
    const response = await axiosHttp.get("/pmo/my/task-time-log");
    return response.data?.data;
  },
  deleteTaskTimeLog: async (data) => {
    const response = await axiosHttp.post("/pmo/task/delete-time-log", data);
    return response.data;
  },
  getTimeSheets: async (year, month) => {
    const response = await insightsHttp.get("/analytica/api/v1/query/execute/time-sheets", { params: { year, month } });
    return response.data;
  }
};
